import { all, fork, put, takeEvery } from 'redux-saga/effects';

import { localeOptions } from '@src/constants/defaultValues';
// eslint-disable-next-line camelcase
import jwt_decode from 'jwt-decode';
import { setCurrentUser } from '@src/helpers/Utils';
import eCobraApi from '@src/api';
import Routes from '@src/helpers/routes';

import Actions, { LOGIN_USER, CHECK_AUTH } from '@src/redux/actions';

export function* watchLoginUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}
function* loginWithEmailPassword({ payload }) {
  const { email, password } = payload.user;
  const { history } = payload;
  try {
    const { jwtoken } = yield eCobraApi.signInWithEmailAndPassword(
      email,
      password
    );

    const { username, userId: id, id_idioma: idLang } = jwt_decode(jwtoken);
    const item = {
      id,
      username,
      img: '/assets/img/RedJinn/logo.jpg',
      role: 0,
      idLang,
      authToken: jwtoken,
      date: new Date().getTime(),
    };

    const { id: locale } = localeOptions[idLang - 1];
    setCurrentUser(item);
    yield put(Actions.settings.changeLocale(locale));
    yield put(Actions.auth.loginUserSuccess(item));
    history.push(Routes.app.projects.base.url());
  } catch (error) {
    const { msg } = error.response.data;
    yield put(Actions.auth.loginUserError(msg));
  }
}

export function* watchCheckAuth() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(CHECK_AUTH, checkAuth);
}
function* checkAuth({ payload }) {
  try {
    const { jwtoken } = yield eCobraApi.checkAuth();
    const updatedUser = { ...payload, authToken: jwtoken };
    setCurrentUser(updatedUser);
    yield put(Actions.auth.checkAuthSuccess(updatedUser));
  } catch (error) {
    setCurrentUser();
    yield put(Actions.auth.checkAuthError());
  }
}

/*
export function* watchRegisterUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(REGISTER_USER, registerWithEmailPassword);
}

const registerWithEmailPasswordAsync = async (email, password) =>
  // eslint-disable-next-line no-return-await
  await auth
    .createUserWithEmailAndPassword(email, password)
    .then((user) => user)
    .catch((error) => error);

function* registerWithEmailPassword({ payload }) {
  const { email, password } = payload.user;
  const { history } = payload;
  try {
    const registerUser = yield call(
      registerWithEmailPasswordAsync,
      email,
      password
    );
    if (!registerUser.message) {
      const item = { uid: registerUser.user.uid, ...currentUser };
      setCurrentUser(item);
      yield put(registerUserSuccess(item));
      history.push(adminRoot);
    } else {
      yield put(registerUserError(registerUser.message));
    }
  } catch (error) {
    yield put(registerUserError(error));
  }
}

export function* watchForgotPassword() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

const forgotPasswordAsync = async (email) => {
  // eslint-disable-next-line no-return-await
  return await auth
    .sendPasswordResetEmail(email)
    .then((user) => user)
    .catch((error) => error);
};

function* forgotPassword({ payload }) {
  const { email } = payload.forgotUserMail;
  try {
    const forgotPasswordStatus = yield call(forgotPasswordAsync, email);
    if (!forgotPasswordStatus) {
      yield put(forgotPasswordSuccess('success'));
    } else {
      yield put(forgotPasswordError(forgotPasswordStatus.message));
    }
  } catch (error) {
    yield put(forgotPasswordError(error));
  }
}

export function* watchResetPassword() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

const resetPasswordAsync = async (resetPasswordCode, newPassword) => {
  // eslint-disable-next-line no-return-await
  return await auth
    .confirmPasswordReset(resetPasswordCode, newPassword)
    .then((user) => user)
    .catch((error) => error);
};

function* resetPassword({ payload }) {
  const { newPassword, resetPasswordCode } = payload;
  try {
    const resetPasswordStatus = yield call(
      resetPasswordAsync,
      resetPasswordCode,
      newPassword
    );
    if (!resetPasswordStatus) {
      yield put(resetPasswordSuccess('success'));
    } else {
      yield put(resetPasswordError(resetPasswordStatus.message));
    }
  } catch (error) {
    yield put(resetPasswordError(error));
  }
}
*/

export default function* rootSaga() {
  yield all([fork(watchLoginUser), fork(watchCheckAuth)]);
}
